export default {
  get: {
		getUserInfo: "/user/get"
	},
	post: {
		getUserPerm: "/user/perm"
	}
}
